/* eslint-disable import/prefer-default-export */
import { AdminConfiguration } from '@centecomm/admin-config-service';
import { useCurrentUser } from '@centecomm/portal-service-react';
import useSettingsFromState from 'State/Settings/Hooks/useSettingsFromState';

export const useIdIsIdtStorageEnabledByPropertyId = (
    propertyId: number | undefined | null,
): { isUsingIdtStorage: boolean; propertyDocumentEnabled: boolean } => {
    const { getPropertyCompanyId } = useCurrentUser();
    const { settings } = useSettingsFromState<AdminConfiguration>();
    const documentManagementSettings = settings?.documentManagement;

    let isUsingIdtStorage = false;
    let propertyDocumentEnabled = false;

    // OO flow
    if (documentManagementSettings && documentManagementSettings.storageType === 0) {
        return {
            isUsingIdtStorage: true,
            propertyDocumentEnabled: documentManagementSettings.propertyDocumentsEnabled || false,
        };
    }

    // Tenant flow
    if (propertyId) {
        const companyId = getPropertyCompanyId(propertyId) || 0;
        isUsingIdtStorage = documentManagementSettings?.companyStorageTypes?.[companyId]?.storageType === 0;
        propertyDocumentEnabled =
            documentManagementSettings?.companyStorageTypes?.[companyId]?.propertyDocumentsEnabled || false;
    }

    return { isUsingIdtStorage, propertyDocumentEnabled };
};
